import { baseUrl } from './routes';

export class ParentsRoutes {
  static get parents(): string {
    return `${baseUrl}/parents`;
  }

  static get profile(): string {
    return `${baseUrl}/parents/profile`;
  }

  static get list(): string {
    return `${baseUrl}/parents/list`;
  }
}
